import { EmptyState } from '@app/components/base/EmptyState';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

/**
 * Empty state shown when a list has no results (e.g. due to filters).
 * Uses EmptyState with default icon/message/help and optionally a button to clear all filters.
 */
export const ListEmptyState = ({ onClearFilters }: { onClearFilters?: () => void }) => {
  return (
    <EmptyState
      action={
        onClearFilters ? (
          <Button
            variant="contained"
            onClick={onClearFilters}
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              px: 4,
              boxShadow: 'none',
              '&:hover': { boxShadow: 'none' },
            }}
          >
            <FormattedMessage
              id="common.listView.clearAllFilters"
              defaultMessage="Limpiar todos los filtros"
            />
          </Button>
        ) : undefined
      }
    />
  );
};
